import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ngx-formly-tabs',
    templateUrl: './formly-tabs.component.html',
    styleUrls: ['./formly-tabs.component.scss']
})
export class FormlyTabsComponent extends FieldType implements OnInit {

    activeTab: boolean[];

    ngOnInit(): void {
        this.activeTab = this.field.fieldGroup.map(f => true);
        this.activeTab[0] = true;
    }

}
